<script setup>
import {RadioGroup, RadioGroupDescription, RadioGroupLabel, RadioGroupOption} from '@headlessui/vue'
import {reactive, ref, watch} from "vue";

const emit = defineEmits(['update:modelValue']);

const props = defineProps({
    'modelValue': Object,
    'options': Array,
    'containerClasses': String,
})

const selectedOption = ref();

const setSelectedOption = (option) => {
    let originalObject = props.options.filter(object => _.isEqual(object, option));

    if (originalObject.length < 1)
        return;

    selectedOption.value = originalObject[0];
}

const updatedModelValue = (modelValue) => {
    setSelectedOption(modelValue);
    emit('update:modelValue',modelValue);
}

setSelectedOption(props.modelValue);

</script>
<template>
    <RadioGroup :model-value="selectedOption" @update:modelValue="updatedModelValue" class="mt-2">
        <RadioGroupLabel class="sr-only">{{ $t('Choose an option') }}</RadioGroupLabel>
        <div :class="containerClasses ? containerClasses : 'space-y-4'">
            <RadioGroupOption as="template" v-for="option in options" :key="option.name"
                              :value="option" :disabled="option.disabled" v-slot="{ checked, active }">
                <div
                    :class="[checked ? 'border-transparent ring-2 ring-primary-500' : 'border-gray-300', active ? 'border-transparent ring-2 ring-primary-500' : '', 'relative block bg-white border rounded-lg shadow-sm px-6 py-4 cursor-pointer sm:flex sm:justify-between focus:outline-none']">
                    <span class="flex items-center">
                        <span class="text-sm flex flex-col">
                            <RadioGroupLabel as="span"
                                             :class="[checked ? 'text-primary-500 font-bold' : 'font-medium text-gray-900', option.description ? 'mb-1' : '']"
                                             v-if="option.name">
                            {{ $t(option.name) }}
                            </RadioGroupLabel>
                            <RadioGroupDescription v-if="option.description" as="span" class="text-gray-700">
                            {{ $t(option.description) }}
                            </RadioGroupDescription>
                        </span>
                    </span>
                </div>
            </RadioGroupOption>
        </div>
    </RadioGroup>
</template>